import { SearchResults } from "../../Shared/scriptts/interfaces";
import { toggleElement } from "../../Shared/scriptts/rootcomponents/toggle";
import { params, executeSearchUrl, displayResults } from '../search-main';

let eventsApplied = false;

/**
 * Displays the work site filter (contains remote and telework options)
 * @param data The data returned from the search API
 */
export function displayWorkSiteFilter(data: SearchResults) {
    setWorkSiteParam();

    document.querySelectorAll<HTMLInputElement>('[name="work_site"]').forEach(elem => {
        elem.checked = (elem.value === 'remote-true' && params.RemoteIndicator?.toString() === 'true')
            || (elem.value === 'remote-false' && params.RemoteIndicator?.toString() === 'false')
            || (elem.value === 'telework' && params.TeleworkIndicator?.toString() === 'true');

        if (!eventsApplied) {
            elem.addEventListener('change', () => workSiteOptionChanged(elem));
        }
    });

    if (!eventsApplied) {
        document.querySelector<HTMLButtonElement>('#clear-filters-work_site')?.addEventListener('click', clearButtonClicked);
    }

    setFilterButtonState();
    eventsApplied = true;
}

function setWorkSiteParam() {
    const clearButton = document.querySelector<HTMLButtonElement>('#clear-filters-work_site');
    const workSiteInputs = document.querySelectorAll<HTMLInputElement>('[name="work_site"]');
    const hasTelework = params.TeleworkIndicator?.toString() === 'true';
    const isFilterSelectable = Array.from(workSiteInputs).some(input => !input.disabled);
    
    if (params.RemoteIndicator?.toString() === 'true' && hasTelework) {
        params.RemoteIndicator = undefined;
        params.TeleworkIndicator = undefined;
    }

    if (!isFilterSelectable || (params.RemoteIndicator == null && !hasTelework)) {
        clearButton?.classList.add('hidden');
        return;
    }

    clearButton?.classList.remove('hidden');
}

function workSiteOptionChanged(elem: HTMLInputElement) {
    const filterButton = document.querySelector<HTMLElement>('#filter-button-work_site');

    if (elem.checked && elem.value === 'remote-true') {
        params.RemoteIndicator = true;
        params.TeleworkIndicator = undefined;
    }
    else if (elem.checked && elem.value === 'remote-false') {
        params.RemoteIndicator = false;
        params.TeleworkIndicator = undefined;
    }
    else if (elem.checked && elem.value === 'telework') {
        params.TeleworkIndicator = true;
        params.RemoteIndicator = undefined;
    }
    else {
        params.RemoteIndicator = undefined;
        params.TeleworkIndicator = undefined;
    }

    params.Page = '1';
    displayResults(executeSearchUrl, false, true);

    if (!filterButton) {
        return;
    }

    toggleElement(filterButton, false);
}

function clearButtonClicked() {
    params.RemoteIndicator = undefined;
    params.TeleworkIndicator = undefined;
    params.Page = '1';
    document.querySelectorAll<HTMLInputElement>('[name="work_site"]').forEach(elem => elem.checked = false);
    displayResults(executeSearchUrl, false, true);
    document.querySelector<HTMLButtonElement>('#clear-filters-work_site')?.classList.add('hidden');
}

function setFilterButtonState() {
    const filterButton = document.querySelector<HTMLButtonElement>('#filter-button-work_site');
    const filterButtonText = document.querySelector<HTMLElement>('#filter-button-text-work_site');
    const remoteInput = document.querySelector<HTMLInputElement>('#work_site-remote');
    const excludeRemoteInput = document.querySelector<HTMLInputElement>('#work_site-excluderemote');
    const teleworkInput = document.querySelector<HTMLInputElement>('#work_site-telework');
    let hasFilter = false;

    if (!filterButton || !filterButtonText || !remoteInput || !excludeRemoteInput || !teleworkInput) {
        return;
    }

    if (remoteInput.checked) {
        filterButtonText.textContent = 'Remote jobs';
        hasFilter = true;
    }
    else if (excludeRemoteInput.checked) {
        filterButtonText.textContent = 'Exclude remote jobs';
        hasFilter = true;
    }
    else if (teleworkInput.checked) {
        filterButtonText.textContent = 'Offers telework';
        hasFilter = true;
    }
    else {
        filterButtonText.textContent = 'Work site';
    }

    if (hasFilter) {
        filterButton.classList.add('button-search-filter-applied');
        filterButton.classList.remove('button-search-filter');
        filterButton.querySelectorAll<HTMLElement>('svg').forEach(icon => {
            icon.classList.add('fill-white');
            icon.classList.remove('fill-gray-darkest');
        });
    }
    else {
        filterButton.classList.remove('button-search-filter-applied');
        filterButton.classList.add('button-search-filter');
        filterButton.querySelectorAll<HTMLElement>('svg').forEach(icon => {
            icon.classList.remove('fill-white');
            icon.classList.add('fill-gray-darkest');
        });
    }
}
